import React from "react";


export default function LatestArticleDetails() {
  return (
    <React.Fragment>
      <div className="latest-article-parallax parallax d-flex justify-content-center align-items-center col-12" />
      <div className="container">
        <h1 className="text-center text-bold my-2">
          What you should learn before first big travel?
        </h1>
        <div className="d-flex justify-content-around">
          <p>By Caitlin Sandra. </p>
          <p className="">Date: 08-15-2018</p>
        </div>
        <article className='latest-paragraph'>
          <p className="text-justify">
            &emsp;Morbi eget faucibus mi, id rutrum enim. Pellentesque non
            commodo magna, vel euismod massa. In hac habitasse platea dictumst.
            Nunc tincidunt ornare porta. Donec vitae lorem non ante molestie
            finibus id non dui. Phasellus gravida, purus at tincidunt feugiat,
            arcu orci volutpat purus, imperdiet tempor dui lectus efficitur
            augue. Vestibulum a condimentum arcu, quis gravida quam. Quisque et
            ante blandit, hendrerit quam sed, ullamcorper est. Maecenas in ex
            eget neque condimentum blandit eu id enim. Proin lacus arcu,
            accumsan eget mollis tincidunt, auctor non lectus. Fusce cursus est
            nec erat efficitur, ac pulvinar sem ullamcorper. Morbi nec est
            pulvinar, lobortis eros nec, sagittis nulla. Donec ullamcorper
            egestas urna, a pulvinar sem posuere at. Fusce vel felis mauris.
            Nulla commodo lorem eget lorem suscipit, sed facilisis eros
            molestie. Fusce aliquet cursus imperdiet. Mauris vel imperdiet
            libero. Aenean viverra ultricies odio, in cursus risus. Vivamus
            bibendum euismod facilisis. Sed et quam ornare, venenatis ligula sit
            amet, hendrerit quam. In nisi urna, suscipit at bibendum a,
            convallis eu enim. Duis egestas mauris eget quam feugiat
            condimentum.Phasellus vitae finibus odio. Praesent et rutrum risus.
            Proin a mattis arcu. Morbi id posuere dolor. Duis ornare nunc eu sem
            scelerisque faucibus.
            <br />
            &emsp; Pellentesque habitant morbi tristique senectus et netus et
            malesuada fames ac turpis egestas. Proin facilisis porttitor metus,
            at lacinia neque. Phasellus euismod blandit ante, quis euismod
            lectus. In malesuada fringilla mattis. Donec fermentum diam in
            ullamcorper malesuada. Phasellus at vestibulum augue, quis
            consectetur massa. Sed molestie nibh vel augue ultricies finibus.
            Quisque at tortor efficitur, imperdiet sapien nec, pharetra neque.
            Vivamus tristique blandit tortor in hendrerit. Pellentesque leo
            lectus, pulvinar et lacus non, interdum pellentesque arcu. Donec
            facilisis sit amet metus non faucibus.
            <br />
            &emsp; Sed tortor justo, sollicitudin et gravida at, auctor ac
            turpis. Ut rhoncus, ante id cursus mollis, sem leo venenatis dolor,
            venenatis posuere nisl metus vel odio. In hac habitasse platea
            dictumst. Donec a gravida massa. Maecenas vestibulum efficitur
            auctor. Etiam feugiat, nunc ac vulputate ultrices, enim mi laoreet
            ex, posuere egestas ipsum orci blandit urna. Quisque ullamcorper
            tortor quis imperdiet lacinia. Donec porta, risus id auctor gravida,
            libero purus auctor nisl, eget ultrices tellus ipsum non sapien.
            Nulla maximus turpis laoreet lorem viverra, eget mattis enim
            convallis. Sed vel risus nec arcu cursus lacinia at eu neque. Mauris
            justo sapien, pharetra a nisl eget, ornare vestibulum enim.
          </p>
        </article>
      </div>
    </React.Fragment>
  );
}

//
//   id:6,
//   title: 'What you should learn before first big travel',
//   autor: 'Caitlin Sandra',
//   date: '2028-08-15',
//   description: 'Morbi eget faucibus mi, id rutrum enim. Pellentesque non commodo magna, vel euismod massa. In hac habitasse platea dictumst. Nunc tincidunt ornare porta. Donec vitae lorem non ante molestie finibus id non dui. Phasellus gravida, purus at tincidunt feugiat, arcu orci volutpat purus, imperdiet tempor dui lectus efficitur augue. Vestibulum a condimentum arcu, quis gravida quam. Quisque et ante blandit, hendrerit quam sed, ullamcorper est. Maecenas in ex eget neque condimentum blandit eu id enim. Proin lacus arcu, accumsan eget mollis tincidunt, auctor non lectus. Fusce cursus est nec erat efficitur, ac pulvinar sem ullamcorper. Morbi nec est pulvinar, lobortis eros nec, sagittis nulla. Donec ullamcorper egestas urna, a pulvinar sem posuere at. Fusce vel felis mauris. Nulla commodo lorem eget lorem suscipit, sed facilisis eros molestie. Fusce aliquet cursus imperdiet. Mauris vel imperdiet libero. Aenean viverra ultricies odio, in cursus risus. Vivamus bibendum euismod facilisis. Sed et quam ornare, venenatis ligula sit amet, hendrerit quam. In nisi urna, suscipit at bibendum a, convallis eu enim. Duis egestas mauris eget quam feugiat condimentum.'
